import React from 'react'

function Image(props) {
    if (props.image) {
        return (
            <figure className="image is-4by3">
                <img src={props.image} alt="Placeholder" />
            </figure>
        )
    } else {
        return (<span></span>)
    }
}

export default Image